export const LOGIN = '/login'
export const LOGIN1 = '/'
export const DASHBOARD = '/dashboard'
export const RECRUITERSIGNUP = '/recruitersignup'
export const RESOURCES = '/resources'
export const CREATEPOSITIONS = '/createPositions'
export const POSITIONS = '/positions'
export const RESOURCEPOSITIONS = '/applyPositions'
export const APPLIEDCANDIDATES = 'position-details'
export const COMPANY = '/company'
export const INFORMATIONPAGE = '/pageInfo'
export const RESOURCEAPPLYPOSITIONS = '/resource-applyPositions'
export const CREATERESOURCES = '/createResources'
export const CREATECOMPANY = '/createCompany'
export const BLACKLISTED = '/blacklisted'
export const REJECTED = '/rejected'
export const INCONTRACT = '/incontract'
export const MYWORKPLACEUSERS = '/myworkplaceusers'
export const SETTINGS = '/settings'
export const COMPANYSETTINGS = '/companysettings'
export const SURVEY = '/survey'
export const COMPANYTIMESHEET = '/companytimesheets'
export const COMPANYTIMESHEETSETTINGS = '/timesheetsettings'
export const CANDIDATETIMESHEET = '/candidatetimesheets'
export const CANDIDATETIMESHEETSETTINGS = '/candidatetimesheetsettings'
export const PUBLICDATABASE = '/publicdatabase'
export const UPLOADHISTORY = '/uploadhistory'
export const JSONRESPONSE = '/jsonresponse'
export const CANDIDATETIMESHEETDOWNLOAD = '/candidatetimesheetdownload'
export const REPORTS = '/reports'
export const SIGNUP = '/crsignup'
export const CRCREATERESOURCES = '/CRcreateresources'
export const CRPOSITIONS = '/crpositions'
export const CRRESOURCES = '/CRresources'
export const CRPOSITIONDETAILS = '/crposition-details'
export const CRAPPLYPOSITIONS = '/crapplypositions'
export const CRRESOURCESTAB = '/crresource'
export const FALLBACKPAGE = '*'
export const REFERANDEARN = '/referedcandidates'
